(function( $ ){
    "use strict";
    $(document).ready(function() {
        $('.product-detail__buy-local').click(function(event) {
            event.preventDefault();
        });
    });
})(jQuery);